// extracted by mini-css-extract-plugin
export default {"wrapper":"commentary_summary-module__wrapper--21Ukf","content":"commentary_summary-module__content--5K2-t","more":"commentary_summary-module__more--3A7Uk"};